export default function PTSHeroSection() {
  return (
    <section className="relative w-full h-[80vh] min-h-[620px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/b8b7c635659503e99f1288cea0e7a40b.jpg"
        alt="Places to stay in Highlands, NC — mountain town surrounded by Blue Ridge forest"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/60" />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ 2026 Local Guide</p>
        <h1 className="font-cormorant text-5xl md:text-7xl text-white font-light leading-none mb-6 max-w-4xl">
          Best Places to Stay<br /><em className="italic">in Highlands, NC</em>
        </h1>
        <p className="text-white/75 font-jost text-sm leading-relaxed max-w-2xl mb-8">
          A complete guide to where to stay in Highlands, North Carolina — covering top-rated cabins, vacation rentals, boutique hotels, and inns. Updated for 2026.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 text-white/60 text-xs font-jost tracking-wide">
          <span className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-[#C9A96E]" />
            </div>
            Cabins &amp; Vacation Rentals
          </span>
          <span className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-building-line text-[#C9A96E]" />
            </div>
            Hotels &amp; Inns
          </span>
          <span className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-line text-[#C9A96E]" />
            </div>
            Real Properties Only
          </span>
        </div>
      </div>
    </section>
  );
}
